export default __webpack_public_path__ + "static/media/[BTCLOD.COM] Sarkodie - Rollies and Cigars (Official Music Video)-320k.f1077d75.mp3";